import {
  applyMiddleware,
  combineReducers,
  legacy_createStore as createStore,
} from "redux";
import { reducer as formReducer } from "redux-form";
import createSagaMiddleware from "redux-saga";
import rootSaga from "../sagas/rootSaga";
import Calc_reducer from "./Calc_reducer";
import Chat_reducer from "./Chat_reducer";
import Main_reducer from "./Main_reducer";

const reducers = combineReducers({
  Calc_reducer,
  Chat_reducer,
  Main_reducer,
  form: formReducer,
});

const sagaMiddleware = createSagaMiddleware();
/*const saveState = (state) => {
    try {
        const serialisedState = JSON.stringify(state);
        window.sessionStorage.setItem('app_state', serialisedState);
    } catch (e) {

    }
};*/
/*const loadState = () => {
    try {
        const serialisedState = window.sessionStorage.getItem('app_state');
        if (!serialisedState) return undefined;
        return JSON.parse(serialisedState);
    } catch (err) {
        return undefined;
    }
};*/

// const oldState = loadState();
const store = createStore(
  reducers,
  // oldState, // Delete and restart, when store not reloaded
  applyMiddleware(sagaMiddleware),
);
store.subscribe(() => {
  // saveState(store.getState());
  store.getState();
});
sagaMiddleware.run(rootSaga);

window["store"] = store;

export default store;
